// import { PAD_ALTERATION_TYPE } from 'app/config/pad';

// const { CREATION , SUSPENSION } = PAD_ALTERATION_TYPE;

// const STATUS = {
//   ACTIVE: 1,
//   INACTIVE: 0
// };

export default class BuildPadDiagnostic {
  constructor(padDiagnostic) {
    this._padDiagnostic = padDiagnostic;
  }

  addPadDiagnosticCode = function (code) {
    this._padDiagnostic.code = code;

    return this;
  };

  setUpdateStatus = function () {
    this._padDiagnostic.itHasBeenUpdated = true;

    return this;
  };

  addPadDiagnosticAlterId = function (padDiagnosticAlterId) {
    this._padDiagnostic.padDiagnosticAlterId = padDiagnosticAlterId;

    return this;
  };

  addPadDiagnosticType = function (type) {
    this._padDiagnostic.padDiagnosticType = type;

    return this;
  };

  // suspendPadDiagnostic = function (id) {
  //   this.addPadDiagnosticType(SUSPENSION);
  //   this.addPadDiagnosticAlterId(id);
  //   this.addStatus(STATUS.INACTIVE);

  //   return this;
  // };

  // unsuspendPadDiagnostic = function () {
  //   this.addPadDiagnosticType(CREATION);
  //   this.addPadDiagnosticAlterId(null);
  //   this.addStatus(STATUS.ACTIVE);

  //   return this;
  // };

  setPadDiagnostic = function (padDiagnostic) {
    this._padDiagnostic = padDiagnostic;

    return this;
  };

  addPadDiagnosticType = function (padDiagnosticType) {
    this._padDiagnostic.padDiagnosticType = padDiagnosticType;

    return this;
  };

  // addPadCardType = function (padCardType) {
  //   this._padDiagnostic.padCardType = padCardType;

  //   return this;
  // };

  addStatus = function (status) {
    this._padDiagnostic.status = status;
    return this;
  };

  cleanPadDiagnostic = function (/*callback*/) {
    return this;
  };

  getPadDiagnostic = function () {
    return this._padDiagnostic;
  };
}
